"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("../../styles");
const sharedStyles_1 = __importDefault(require("../sharedStyles"));
const styles = styles_1.createStyles((theme) => {
    const rest = __rest(sharedStyles_1.default(theme), []);
    const clickable = {
        transition: theme.transition.create(['box-shadow', 'background-color']),
        cursor: 'pointer',
        boxShadow: 'none',
        textDecoration: 'inherit',
        color: 'inherit',
        '&:hover, &:focus': {
            zIndex: 1,
            boxShadow: theme.shadows[2],
            borderColor: 'transparent',
            backgroundColor: theme.palette.surface,
        },
        '&:focus': {
            outline: `3px solid ${theme.palette.light('primary')}`,
        },
        '&:active': {
            outline: 'none',
        },
    };
    return Object.assign(Object.assign({}, rest), { root: {
            zIndex: 0,
            backgroundColor: theme.palette.light('background'),
            borderBottom: `1px solid ${theme.palette.border}`,
            '&:nth-child(even)': {
                backgroundColor: theme.palette.dark('surface'),
            },
            'a&': clickable,
        }, clickable });
});
exports.default = styles_1.withStyles(styles);
